import React from 'react';
import StoryCard from './share/StoryCard';

/**
 * A Party Starter as a 1080×1920 story. While the floor climbs: the bar, the number and the solid
 * gradient CTA (the money move). Once met: GOAL MET and a what's-next ring.
 */
export default function PartyStarterStoryCard({
  variant = 'host', init = 'R', topline = '', keyword = 'PARTY', words = '', meta = '', pct = null, frac = '', number = '', line = '',
  cta = null, template = 'ring', image = null, refEl,
}) {
  const met = variant === 'soldout';
  return (
    <StoryCard
      template={template} image={image} fallback="swirl" init={init}
      status={met ? 'GOAL MET' : 'FUNDING'} statusBg={met ? '#B9F2C9' : '#FFCCE6'}
      topline={topline} keyword={keyword} words={words} meta={meta} pct={pct} frac={frac} number={number} line={line}
      cta={met ? 'SEE WHAT’S STARTING NEXT →' : (cta?.label || 'PLEDGE')} ctaKind={met ? 'ring' : 'solid'} refEl={refEl}
    />
  );
}
